import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

export const StyledButton = styled.button`
  width: 120px;
  height: 42px;
  border: 2px solid #ecedf1;
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  color: #03589c;
  background-color: white;
`;

function Button({ children, ...props }) {
  return <StyledButton {...props}>{children}</StyledButton>;
}

Button.propTypes = {
  children: PropTypes.string,
};

export default Button;
